function ProductCtrl(toaster,$state,$auth,$stateParams, ProductService, AppSettings, CommonService, $scope, $rootScope) {
  'ngInject';

  $rootScope.$on("UpdateProductCostFromNotification", function(event, product_cost){
    vm.updateProductCostFromNotification(product_cost);
  });

  const vm = this;
  vm.loading = false;
  vm.dataloading = false;
  vm.btndisabled = false;
  vm.responseReceived = false;
  vm.orgId = !$stateParams.orgId ? $rootScope.currentOrg : $stateParams.orgId;
  var auth_header = $auth.retrieveData('auth_headers');

  if(auth_header)
  {
    vm.exportExcel= `${AppSettings.apiUrl}/organizations/${$stateParams.orgId}/product_costs.xlsx` + "?access-token=" + auth_header['access-token'] + "&client="+ auth_header['client'] + "&uid=" + auth_header['uid'];
  }

  if ($stateParams.id) {

    ProductService.getProductCost($stateParams.orgId, $stateParams.id,function(response){

      vm.productCostForm = response.data;
    });
  } else {
    vm.productCostForm = {};
  }

  vm.productFileForm = {};
  vm.productList = [];
  vm.pageNumber = !$stateParams.pageNumber ? 1 : $stateParams.pageNumber;
  vm.size = !$stateParams.size ? 50 : $stateParams.size;
  vm.sku = !$stateParams.sku ? '' : $stateParams.sku;
  vm.fnsku = !$stateParams.fnsku ? '' : $stateParams.fnsku;
  vm.todate = !$stateParams.todate? '' : $stateParams.todate;
  vm.fromdate = !$stateParams.fromdate? '' : $stateParams.fromdate;
  vm.sortBy = !$stateParams.sortBy? '' : $stateParams.sortBy;
  vm.sortFlag = false;
  vm.regex = '^[-+]?[0-9]*\.?[0-9]+$';
  vm.dateRegex = AppSettings.dateRegex;
  vm.role = $auth.user.role;
  vm.adminUser = false;

  vm.init = function(){
    vm.url = `/organizations/${vm.orgId}/product_costs.json?page=${vm.pageNumber}&size=${vm.size}&by_sku=${vm.sku}&by_fnsku=${vm.fnsku}&by_from=${vm.fromdate}&by_to=${vm.todate}&sort=${vm.sortBy}`;
    vm.dataloading = true;
    ProductService.getData($stateParams.orgId, vm.url, vm.pageNumber, vm.size, function (response) {
      vm.dataloading = false;
      if(response.status == 200) {
        vm.adminUser = $auth.user.id == 1 ? true : vm.adminUser;
        vm.productCostResponse = response.data;
        vm.currentPage = !vm.productCostResponse.pagination ? 1 : vm.productCostResponse.pagination.current_page;
        vm.totalPages = !vm.productCostResponse.pagination ? 1 : vm.productCostResponse.pagination.total_pages;
        vm.productList = response.data.product_costs;
      }
    });
  };

  vm.updateProductCostFromNotification = function(data){
    if(Array.isArray(data))
    {
      vm.init();
    }
  };

  vm.search = function (sku, fnsku, fromdate, todate) {
    if (vm.role == 'client') {
      $state.go('client.clientDashboard.productListing', { pageNumber: 1, size: vm.size, sku: sku, fnsku: fnsku, fromdate: fromdate, todate: todate })
    } else {
      $state.go('user.organization.settingView.productListing', { pageNumber: 1, size: vm.size, sku: sku, fnsku: fnsku, fromdate: fromdate, todate: todate })
    }
  };

  vm.sortFlag = function(param) {
    var currentSort = $stateParams.sortBy;
    if(currentSort && currentSort.includes(param))
    {
      if(!currentSort.includes('-'))
      {
        return false;
      }
    }
    return true;
  };

  vm.sort = function(param) {
    var currentSort = $stateParams.sortBy;
    if(currentSort && currentSort.includes(param))
    {
      if(!currentSort.includes('-'))
      {
        param = '-' + param;
      }
    }
    if (vm.role == 'client') {
      $state.go('client.clientDashboard.productListing', { sortBy: param });
    } else {
      $state.go('user.organization.settingView.productListing', { sortBy: param });
    }
  };

  vm.paginate = function (param) {
    vm.url = vm.productCostResponse.links[param];
    if (vm.url) {
      var arr = vm.url.split('?');
      vm.pageNumber = CommonService.getParameterByName('page', vm.url);
      vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
      if (vm.role == 'client') {
        $state.go('client.clientDashboard.productListing', { pageNumber: vm.pageNumber, size: vm.size });
      } else {
        $state.go('user.organization.settingView.productListing', { pageNumber: vm.pageNumber, size: vm.size });
      }
    }
  };

  vm.rowChange = function (param, pageSize) {
    vm.url = vm.productCostResponse.links[param];
    var arr = vm.url.split('?');
    vm.pageNumber = 1;
    vm.size = pageSize;
    vm.url = arr[0]+ '.json?page='+ vm.pageNumber + '&size='+ vm.size;
    if (vm.role == 'client') {
      $state.go('client.clientDashboard.productListing', { pageNumber: vm.pageNumber, size: vm.size });
    } else {
      $state.go('user.organization.settingView.productListing', { pageNumber: vm.pageNumber, size: vm.size });
    }
  };

  vm.saveFile = function() {
    vm.loading = true;
    vm.btndisabled = true;
    ProductService.saveFile(vm.productFileForm, vm.orgId, function(response) {
      vm.loading = false;
      vm.btndisabled = false;
      vm.productFileForm = {};
      if(response.status >= 200 & response.status <300){
        toaster.pop('info', 'File uploaded successfully');
      }else{
        toaster.pop('error', CommonService.throwError(response));
      }
    });
  };

  vm.inlineSave = function(proList) {
      if(proList.avg_cost!= null){
        ProductService.editProductCost(proList, vm.orgId, proList.id, function(response) {
        if(response.status >= 200 & response.status <300){
          toaster.pop('info', 'New product cost updated.');
          // vm.productList = [response.data].concat(vm.productList);
        }
        else{
          toaster.pop('error', CommonService.throwError(response));
        }
      });
    }
    else{
      toaster.pop('error', 'AVG Cost cannot be empty');
    }
  }


  vm.saveProductCost = function(productForm) {
    vm.responseReceived = false;
   if ($stateParams.id) {
    ProductService.editProductCost(vm.productCostForm, vm.orgId, $stateParams.id, function(response){
      vm.productCostForm = {};
       if(response.status >= 200 && response.status <300){
        toaster.pop('info', 'New product Cost updated.');
        if (vm.role == 'client') {
          $state.go('client.clientDashboard.productListing', { inherit: false });
        } else {
          $state.go('user.organization.settingView.productListing', { inherit: false });
        }
      }else{
        toaster.pop('error', CommonService.throwError(response));
      }
    });
  }
  else{
    ProductService.saveProductCost(vm.productCostForm, vm.orgId, function(response) {
      vm.responseReceived = true;
      vm.productCostForm = {};
      productForm.$setPristine();
      productForm.$setUntouched();
      if(response.status >= 200 & response.status <300){
        toaster.pop('info', 'New product Cost saved.');
        vm.init();
      }else{
        toaster.pop('error', CommonService.throwError(response));
      }
    })
  }
};

  vm.appendNewOrUpdateExisting = function(row){
    let index = vm.productList.map(function(d){
        return d.id;
    }).indexOf(row.id);
    if(index == -1){
      vm.productList = [row].concat(vm.productList);
    } else {
      vm.productList[index] = row;
    }
  };

vm.editProductCost = function(proCostId) {
  if (vm.role == 'client') {
    $state.go('client.clientDashboard.productNew', { orgId: $stateParams.orgId, id: proCostId }, { inherit: false });
  } else {
    $state.go('user.organization.settingView.productNew', { orgId: $stateParams.orgId, id: proCostId }, { inherit: false });
  }
  $('html,body').animate({
          scrollTop: $("#product_form").offset().top - 100},
        'slow');
}

vm.deleteProductCost= function(proCostId) {
  swal({
      title: "Are you sure?",
      text: "Do you want to delete this product Cost?",
      icon: "warning",
      dangerMode: true,
      buttons: [true, true]
  })
  .then(willDelete => {
    if (willDelete) {
      ProductService.deleteProductCost($stateParams.orgId, proCostId, function(response){
        vm.removeProductCost(proCostId);
        if(response.status == 204) {
          toaster.pop('info', 'Product Cost deleted');
        } else {
          toaster.pop('error', CommonService.throwError(response));
        }
      });
    }
  });
}

vm.removeProductCost = function(proCostId){
    for(var i = vm.productList.length - 1; i >= 0; i--){
      if(vm.productList[i].id == proCostId){
       vm.init();
      }
    }
  };

vm.onPickadayTo = function (pikaday) {
  vm.todate = pikaday.toString();
  vm.fromDatePicker.setMaxDate(new Date(vm.todate));
};

vm.onPickadayFrom = function(pikaday) {
  vm.fromdate = pikaday.toString();
  vm.toDatePicker.setMinDate(new Date(vm.fromdate));
};

vm.addProduct = function () {
  if(vm.role == 'admin'){
    $state.go('user.organization.settingView.productNew', {inherit: false});
  }else{
    $state.go('client.clientDashboard.productNew', {orgId: vm.orgId});
  }
};

  vm.deleteAllProductCosts = function () {
    swal({
      title: "Are you sure?",
      text: "Do you want to delete all of the costs associated with this organization?",
      icon: "warning",
      dangerMode: true,
      buttons: [true, true],
    })
    .then(willDelete => {
      if (willDelete) {
        ProductService.deleteAllProductCosts($stateParams.orgId, function(response){
          if(response.status >= 200 && response.status < 300) {
            vm.productList = [];
            toaster.pop('info', response.data.message);
          } else {
            toaster.pop('error', CommonService.throwError(response));
          }
        });
      }
    });
  };

  vm.getStatusClass = function (status) {
    let flag = '';
    switch (status) {
      case 'active':
        flag = 'active-flag';
        break;
      case 'inactive':
        flag = 'inactive-flag';
        break;
      default:
    }
    return flag;
  };
}

export default{
  name: 'ProductCtrl',
  fn: ProductCtrl
}
